import { takeLatest, select, call } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { putSuccess, putError } from '../helpers'
import authUser from "../../apis/wpApi/authUser";
import { updateNewsletterDataCall } from "../../apis/wpApi/apiCalls";
import { NEWSLETTERLOCAL } from "../../constants/state";
import { newsletterFilterData } from "./watchNewsletterFilterRequest";


const getNewsletterData = state => ({
    newsletterLocalData: state.getIn([NEWSLETTERLOCAL])
})

function* updateData() {
    try {
        const apiKey = yield call(authUser.getToken)
        const { newsletterLocalData } = yield select(getNewsletterData)

        if(!newsletterLocalData) {
            throw new Error('No newsletter data') 
        }
        const filteredNewsletterData = yield call(newsletterFilterData)
        const dataToUpdate = yield newsletterLocalData.setIn(['newsletters'], filteredNewsletterData).toJS()
        const response = yield call(updateNewsletterDataCall, apiKey, dataToUpdate)

        if(!response || !response.status || 200 !== response.status || !response.data) {
            throw new Error('Could not update data')
        } else {
            yield putSuccess(actionTypes.NEWSLETTER_UPDATE_SUCCESS, response.data)
        }
    } catch(e) {
        console.log('ERROR', e)
        yield putError(actionTypes.NEWSLETTER_UPDATE_ERROR, e.message)
        // yield call(overlaySetOverlayType, OVERLAY_TEXT)
    }
}

function* watchNewsletterUpdateRequest() {
    yield takeLatest(actionTypes.NEWSLETTER_UPDATE_REQUEST, updateData);
}

export default watchNewsletterUpdateRequest
